import { render } from "./audit-log-per-day.vue?vue&type=template&id=2ac5a71c"
import script from "./audit-log-per-day.vue?vue&type=script&lang=js"
export * from "./audit-log-per-day.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__